import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import useInactivityLogout from './hooks/useInactivityLogout';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PntsPage from './pages/PntsPage';
import PntDetallePage from './pages/PntDetallePage';
import FirmasPage from './pages/FirmasPage';
import TemperaturaPage from './pages/TemperaturaPage';
import LimpiezaPage from './pages/LimpiezaPage';
import PlagasPage from './pages/PlagasPage';
import DevolucionesPage from './pages/DevolucionesPage';
import NoConformidadesPage from './pages/NoConformidadesPage';
import ProveedoresPage from './pages/ProveedoresPage';
import FormacionPage from './pages/FormacionPage';
import RecepcionesPage from './pages/RecepcionesPage';
import IncidenciasPage from './pages/IncidenciasPage';
import ArchivosPage from './pages/ArchivosPage';
import InformesPage from './pages/InformesPage';
import UsuariosPage from './pages/UsuariosPage';
import OrganigramaPage from './pages/OrganigramaPage';
import AuditoriaPage from './pages/AuditoriaPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}>
      <div className="spinner" style={{ width:36, height:36 }} />
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : children;
}

function AppRoutes() {
  const { user, logout } = useAuth();

  // Cierre automático de sesión tras 30 minutos de inactividad (estándar AEMPS)
  useInactivityLogout(logout, !!user);

  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="pnts" element={<PntsPage />} />
        <Route path="pnts/:id" element={<PntDetallePage />} />
        <Route path="firmas" element={<FirmasPage />} />
        <Route path="temperatura" element={<TemperaturaPage />} />
        <Route path="limpieza" element={<LimpiezaPage />} />
        <Route path="plagas" element={<PlagasPage />} />
        <Route path="devoluciones" element={<DevolucionesPage />} />
        <Route path="no-conformidades" element={<NoConformidadesPage />} />
        <Route path="proveedores" element={<ProveedoresPage />} />
        <Route path="formacion" element={<FormacionPage />} />
        <Route path="recepciones" element={<RecepcionesPage />} />
        <Route path="incidencias" element={<IncidenciasPage />} />
        <Route path="archivos" element={<ArchivosPage />} />
        <Route path="informes" element={<InformesPage />} />
        <Route path="usuarios" element={<UsuariosPage />} />
        <Route path="organigrama" element={<OrganigramaPage />} />
        <Route path="auditoria" element={<AuditoriaPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
